import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-trash',
  standalone: true,
  templateUrl: './icon-trash.component.html',
  styleUrl: './icon-trash.component.css'
})
export class IconTrashComponent { }
